import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchSignupContractSetFromTemplateQuery,
  Flex_FetchSignupContractSetFromTemplateQueryVariables,
} from '~/typings/graphql';
import { trackError } from '~/utils/tracking';
import { FETCH_SIGNUP_CONTRACT_SET } from './fetch-signup-contract-set-from-template.queries';

export interface SignupContractVersion {
  id: number;
  displayName: string;
  internalName: string;
  contractType: string;
  fileUrl: string;
  presignedUrl?: string | null;
  scrollRequired: boolean;
  signatureType: string;
  contractId: number;
  version: number;
  stateId?: number | null;
}

export interface ContractSet {
  contracts: (SignupContractVersion | null)[] | null;
}

export interface FetchSignupContractSetParams {
  signupContractTemplateId: number;
}
export interface FetchSignupContractSetResponse {
  contractSet: ContractSet | null;
}

export const fetchSignupContractSet = async (
  params: FetchSignupContractSetParams,
): Promise<FetchSignupContractSetResponse> => {
  try {
    const { signupContractTemplateId } = params;

    const { data } = await apolloClient.query<
      Flex_FetchSignupContractSetFromTemplateQuery,
      Flex_FetchSignupContractSetFromTemplateQueryVariables
    >({
      query: FETCH_SIGNUP_CONTRACT_SET,
      variables: { signupContractTemplateId },
    });

    const contractSet = data.signupContractSets?.contractSet;
    if (!contractSet) {
      trackError(new Error('No contract set found for the provided template ID'));
      throw new Error('Something went wrong');
    }
    const { contracts } = contractSet;

    return { contractSet: { contracts } };
  } catch (error) {
    throw new Error(error.message);
  }
};
